// extracted by mini-css-extract-plugin
export default {"inputBorders":"Input_inputBorders__THYad","inputWrapper":"Input_inputWrapper__9Qegx"};